<ng-container *ngIf="isManager">
  <nz-spin [nzSpinning]="loading$ | async">
    <nz-row [nzGutter]="[5, 5]">
      <ng-container *ngFor="let group of icons.controls">
        <nz-col
          [nzXXl]="4"
          [nzXl]="6"
          [nzLg]="6"
          [nzMd]="6"
          [nzSm]="6"
          [nzXs]="12"
        >
          <app-lot-icon
            [icon]="group.value.icon"
            [clickable]="true"
            [enabled]="group.value.enabled"
            (enabledChange)="group.controls.enabled.setValue($event)"
          ></app-lot-icon>
        </nz-col>
      </ng-container>
    </nz-row>
  </nz-spin>
</ng-container>

<nz-row *ngIf="!isManager" [nzGutter]="[5, 5]">
  <ng-container *ngFor="let icon of lotIcons">
    <nz-col
      *ngIf="showIconByRole(icon)"
      [nzXXl]="4"
      [nzXl]="6"
      [nzLg]="6"
      [nzMd]="6"
      [nzSm]="6"
      [nzXs]="12"
    >
      <app-lot-icon [icon]="icon" [enabled]="true" [clickable]="false"></app-lot-icon>
    </nz-col>
  </ng-container>
</nz-row>
